var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreatedAtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.26667 0C3.39043 0 3.50913 0.0491665 3.59665 0.136684C3.68417 0.2242 3.73333 0.342899 3.73333 0.466667V0.933333H9.33333V0.466667C9.33333 0.342899 9.3825 0.2242 9.47002 0.136684C9.55753 0.0491665 9.67623 0 9.8 0C9.92377 0 10.0425 0.0491665 10.13 0.136684C10.2175 0.2242 10.2667 0.342899 10.2667 0.466667V0.933333C11.816 0.933333 13.0667 2.184 13.0667 3.73333V11.2C13.0667 12.7493 11.816 14 10.2667 14H2.8C1.25067 14 0 12.7493 0 11.2V3.73333C0 2.184 1.25067 0.933333 2.8 0.933333V0.466667C2.8 0.342899 2.84917 0.2242 2.93668 0.136684C3.0242 0.0491665 3.1429 0 3.26667 0ZM12.1333 3.73333V4.66667H0.933333V3.73333C0.933333 2.70667 1.76867 1.86667 2.8 1.86667V2.33333C2.8 2.4571 2.84917 2.5758 2.93668 2.66332C3.0242 2.75083 3.1429 2.8 3.26667 2.8C3.39043 2.8 3.50913 2.75083 3.59665 2.66332C3.68417 2.5758 3.73333 2.4571 3.73333 2.33333V1.86667H9.33333V2.33333C9.33333 2.4571 9.3825 2.5758 9.47002 2.66332C9.55753 2.75083 9.67623 2.8 9.8 2.8C9.92377 2.8 10.0425 2.75083 10.13 2.66332C10.2175 2.5758 10.2667 2.4571 10.2667 2.33333V1.86667C11.2933 1.86667 12.1333 2.702 12.1333 3.73333ZM0.933333 11.2V5.6H12.1333V11.2C12.1333 12.2267 11.298 13.0667 10.2667 13.0667H2.8C1.77333 13.0667 0.933333 12.2313 0.933333 11.2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatedAtIcon);
export default __webpack_public_path__ + "static/media/createdAtIcon.2cf365b571213bd33b338c3f27f3f259.svg";
export { ForwardRef as ReactComponent };